import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Contact() {
  const [formStatus, setFormStatus] = useState(false);
  const [query, setQuery] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = () => (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setQuery((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.entries(query).forEach(([key, value]) => {
      formData.append(key, value);
    });

    axios
      .post(
        "https://getform.io/f/2e22c0a8-f77f-44aa-a939-1f5c548739e5",
        formData,
        { headers: { Accept: "application/json" } }
      )
      .then(function (response) {
        setFormStatus(true);
        setQuery({
          name: "",
          email: "",
          message: "",
        });
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div className="contact-part">
      <p className="contact-p1">
        <span>　</span>*は必須項目
      </p>
      <form
        acceptCharset="UTF-8"
        method="POST"
        onSubmit={handleSubmit}
        id="gatsbyForm"
      >
        <div className="contact-input-part">
          <label>氏名*</label>
          <br />
          <input
            type="text"
            placeholder=""
            name="name"
            required
            value={query.name}
            onChange={handleChange()}
            className="contact-input"
          />
          <p className="text-muted"></p>
        </div>
        <div className="contact-input-part">
          <label>メールアドレス*</label>
          <br />
          <input
            type="email"
            placeholder="name@example.com"
            name="email"
            required
            value={query.email}
            onChange={handleChange()}
            className="contact-input"
          />
          <p className="text-muted"></p>
        </div>
        <div className="contact-input-part">
          <label>問い合わせ内容*</label>
          <br />
          <textarea
            type="textarea"
            rows={8}
            name="message"
            required
            value={query.message}
            onChange={handleChange()}
            className="contact-textarea"
          />
        </div>
        <br />
        <p className="contact-p1">
          送信することで「個人情報保護方針」に同意したこととみなします。
        </p>
        <div className="contact-btn-part">
          <button className="contact-btn" type="submit">
            送　信
          </button>
          <br />
          {formStatus ? (
            <div className="alert alert-success">
              お問い合わせ内容が送信されました。
            </div>
          ) : (
            ""
          )}
        </div>
      </form>
    </div>
  );
}
